import React, { Fragment, useEffect, useRef } from "react";
import Header from "../components/partials/Header";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Fade,
  Alert,
} from "reactstrap";
import Footer from "../components/partials/Footer";
import { useState } from "react";
import { connect } from "react-redux";
import { mailReset, sendMail } from "../redux/actions/mailActions";

const ContactUs = (props) => {
  // 0=> nothing , 1 => success, -1=> danger
  let [alert, setAlert] = useState(0);
  let cform = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);

    console.log(alert);
  }, []);
  let { mailsent, loading } = props;

  return (
    <Fragment>
      <div className="contact_us_bg">
        <Header
          {...props}
          background={false}
          login={false}
          heading="Contact Us"
        />
        <div className="margin-top-fix text-white-1">
          <Container>
            <Row className="mb-5">
              <Col lg={6}>
                <div className="d-flex justify-content-center mt-5 pt-5 align-items-center">
                  <div>
                    <h4>Get In Touch !</h4>
                    <h5 className="mt-4">
                      Fill Up This Form And Our Team <br /> Will Get Back To
                      You.
                    </h5>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="mt-5 mb-5 mt-lg-0">
                <div className="form-wrapper">
                  {mailsent == true ? (
                    <Fade
                      in={mailsent == true}
                      onEnter={(e) => {
                        window.setTimeout(() => props.mailReset(), 5000);
                      }}
                    >
                      <Alert isOpen={mailsent == true} color="success">
                        Message Sent.
                      </Alert>
                    </Fade>
                  ) : mailsent == false ? (
                    <Fade
                      in={mailsent == false}
                      onEnter={(e) => {
                        window.setTimeout(() => props.mailReset(), 5000);
                      }}
                    >
                      <Alert isOpen={mailsent == false} color="danger">
                        Opps! Some Error Occured!
                      </Alert>
                    </Fade>
                  ) : (
                    ""
                  )}
                  <Form
                    ref={cform}
                    onSubmit={async (e) => {
                      e.preventDefault();
                      let obj = {
                        name: e.target.name.value,
                        respond_email: e.target.email.value,
                        message: e.target.message.value,
                        email: "a.omar@springyuniverse.com",
                      };
                      props.sendMail(obj);
                      //   alert("Under Development");
                      // let url = "https://us-central1-cr-mobile-13fb4.cloudfunctions.net/app/api/v1/mail/sendMail"
                      // let res = await axios({
                      //     method: 'post',
                      //     url,
                      //     data: obj,
                      // });
                      // if(res.status == 200)
                      //     setAlert(1)
                      // else
                      //     setAlert(-1)
                    }}
                  >
                    <FormGroup>
                      <Input
                        type="text"
                        placeholder="Name"
                        className="form=control"
                        name="name"
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Input
                        type="email"
                        placeholder="Email"
                        className="form=control mt-3"
                        name="email"
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Input
                        type="textarea"
                        placeholder="Message"
                        className="form=control mt-3"
                        name="message"
                        required
                      />
                    </FormGroup>
                    <Button
                      disabled={loading}
                      block
                      className="w-100 mt-3 bg-purple-1 border-0 py-4 "
                      style={{ borderRadius: 24 }}
                    >
                      Send Message
                    </Button>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="bg-dark-1 about-us-container">
        <Container>
          <h2 className="text-red-1 pt-5"> About Us</h2>
          <p className="text-white-1 about-us-p">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eget
            turpis malesuada tincidunt a, erat. Posuere vulputate donec amet,
            dolor ut hac. Sed eu urna purus congue. Hendrerit lectus amet
            aliquam ornare condimentum vitae duis.
          </p>
          <div
            className=" mt-2 pt-5 pb-5 justify-content-center "
            style={{ marginLeft: "8%" }}
          >
            <h3 className="text-yellow-1"> Safety System</h3>
            <p className="text-white-1 about-us-p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
              eget turpis malesuada tincidunt a, erat. Posuere vulputate donec
              amet, dolor ut hac. Sed eu urna purus congue. Hendrerit lectus
              amet aliquam ornare condimentum vitae duis.
            </p>
            <ul className="text-white-1 text-ceter">
              <li className="mt-3 safety-system-heading">Payment System</li>
              <li className="mt-3">
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor ut hac. Sed eu urna purus congue. Hendrerit
                  lectus amet aliquam ornare condimentum vitae duis.
                </p>
              </li>
              <li>
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor ut hac. Sed eu urna purus congue. Hendrerit
                  lectus amet aliquam ornare condimentum vitae duis.Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit. Morbi eget turpis
                  malesuada tincidunt a, erat. Posuere vulputate donec amet,
                  dolor ut hac. Sed eu urna purus congue. Hendrerit lectus amet
                  aliquam ornare condimentum vitae duis.
                </p>
              </li>
              <li className="mt-3 safety-system-heading">SSL</li>
              <li className="mt-3">
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor
                </p>
              </li>
              <li>
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor ut hac. Sed eu urna purus congue. Hendrerit
                  lectus amet aliquam ornare condimentum vitae duis
                </p>
              </li>
              <li className="mt-3 safety-system-heading">Encryption</li>
              <li className="mt-3">
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor
                </p>
              </li>
              <li>
                <p className="about-us-p">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
                  eget turpis malesuada tincidunt a, erat. Posuere vulputate
                  donec amet, dolor ut hac. Sed eu urna purus congue. Hendrerit
                  lectus amet aliquam ornare condimentum vitae duis
                </p>
              </li>
            </ul>
          </div>
        </Container>
      </div>
      <Footer />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    // auth: state.auth,
    loading: state.mail.loading,
    mailsent: state.mail.mailsent,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendMail: (mail) => dispatch(sendMail(mail)),
    mailReset: () => dispatch(mailReset()),
    // addGameToCart: (id) => dispatch(addGameToCard(id)),
    // removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
